import { render, staticRenderFns } from "./Passengers.html?vue&type=template&id=1466b6e5&scoped=true&external"
import script from "./Passengers.js?vue&type=script&lang=js&external"
export * from "./Passengers.js?vue&type=script&lang=js&external"
import style0 from "./Passengers.vue?vue&type=style&index=0&id=1466b6e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1466b6e5",
  null
  
)

export default component.exports